import { Provider } from '@plvs/graphql'
import { GenericConnection } from '@plvs/rally/features/account/connections/GenericConnection'
import { PlayStationNetworkConnection } from './PlaystationNetworkConnection'
import { EpicGamesConnection } from './EpicGamesConnection'
import { NintendoConnection } from './NintendoConnection'
import { ProviderConnection } from './ProviderConnection'

export const gameConnectionComponentMap: ComponentMap[] = [
  { Component: ProviderConnection, name: Provider.Riot },
]

export const platformConnectionComponentMap: ComponentMap[] = [
  { Component: ProviderConnection, name: Provider.Vesl },
  { Component: ProviderConnection, name: Provider.BattleDotNet },
  {
    Component: EpicGamesConnection,
    name: Provider.EpicGames,
  },
  {
    Component: ProviderConnection,
    name: Provider.Discord,
  },
  {
    Component: ProviderConnection,
    name: Provider.Spin,
  },
  {
    Component: NintendoConnection,
    name: Provider.Nintendo,
  },
  { Component: ProviderConnection, name: Provider.XBoxLive },
  {
    Component: PlayStationNetworkConnection,
    name: Provider.PlayStationNetwork,
  },
  {
    Component: ProviderConnection,
    name: Provider.Twitch,
  },
  {
    Component: ProviderConnection,
    name: Provider.Youtube,
  },
  {
    Component: GenericConnection,
    name: Provider.ChessDotCom,
  },
  {
    Component: GenericConnection,
    name: Provider.ChessKid,
  },
  {
    Component: GenericConnection,
    name: Provider.StreetFighter,
  },
  {
    Component: GenericConnection,
    name: Provider.ElectronicArts,
  },
  {
    Component: GenericConnection,
    name: Provider.Nba2K,
  },
  {
    Component: GenericConnection,
    name: Provider.MarvelRivals,
  },
  {
    Component: GenericConnection,
    name: Provider.PokemonUnite,
  },
  {
    Component: GenericConnection,
    name: Provider.F1,
  },
]

export interface ComponentMap {
  Component: any
  name: string
}
